import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';

export interface WorklistSubmissionCanDeactivate {
  hasUnsavedRubricChanges(): boolean;
}

export const worklistSubmissionCanDeactivateGuard: CanDeactivateFn<WorklistSubmissionCanDeactivate> = async (
  component: WorklistSubmissionCanDeactivate,
  currentRoute,
  currentState,
  nextState
) => {
  // If component doesn't implement the interface, allow navigation
  if (!component || typeof component.hasUnsavedRubricChanges !== 'function') {
    return true;
  }

  // Check if there are unsaved changes
  if (!component.hasUnsavedRubricChanges()) {
    return true;
  }

  // Show confirmation dialog
  const alertController = inject(AlertController);
  const alert = await alertController.create({
    header: 'Unsaved Changes',
    message: 'You have unsaved rubric changes. Are you sure you want to leave this page?',
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'secondary',
      },
      {
        text: 'Leave',
        role: 'destructive',
        handler: () => {
          return true;
        },
      },
    ],
  });

  await alert.present();
  const result = await alert.onDidDismiss();

  // Return true if user confirmed leaving (destructive role), false if cancelled
  return result.role === 'destructive';
};

